import { customTheme } from '../../../../../theme/MuiThemeProvider/theme';

export const styles = {
  footer: {
    borderTop: `1px solid ${customTheme.custom.black.B10}`,
    borderRadius: '0 0 10px 10px',
    backgroundColor: customTheme.palette.secondary.S20,
    height: '38px',
  },
  cell: {
    boxSizing: 'border-box',
    height: '38px',
    display: 'table-cell',
    width: '222px',
    padding: '8px',
    borderBottom: 'none',
    textAlign: 'left',
    color: customTheme.custom.black.B100,

    ':first-of-type': {
      padding: '10px 8px 10px 24px',
    },

    ':last-of-type': {
      padding: '10px 24px 10px 8px',
    },
  },
  totalCell: (width: string) => ({
    width,
    minWidth: `${width}`,
    fontSize: '12px',
    fontWeight: '600',
    lineHight: '16px',
  }),
  amountCell: (width: string) => ({
    width,
    minWidth: `${width}`,
    fontSize: '12px',
    lineHeight: '18px',
  }),
  quoteCell: {
    fontSize: '12px',
    fontWeight: '600',
    lineHight: '18px',
    color: customTheme.palette.secondary.S100,
    width: '208px',
    minWidth: '208px',
  },
  totalWrap: {},
  actionsCell: {
    width: '40px',
    minWidth: '40px',
  },
};
